import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './blocks/config/prod.config';
import { DeviceConfigurerServiceAppModule } from './app.module';

ProdConfig();

if (module['hot']) {
    module['hot'].accept();
}

platformBrowserDynamic().bootstrapModule(DeviceConfigurerServiceAppModule);



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.main.ts